import { words } from "../meet-copy";

import type { CogentWidgetProps } from "../widget-types";
import s from "../cogent.module.css";

export function ChatSetup({
  name,
  start,
}: {
  name: string;
  start: CogentWidgetProps["start"];
}) {
  return (
    <div data-testid="cogent-start">
      <div className={s.row}>
        <p className={s.soft}>
          {start?.text ??
            words({
              key: "setup.ready",
              values: { name },
            })}
        </p>
        {start?.label && start.onAction ? (
          <button
            type="button"
            className={s.link}
            disabled={start.busy}
            onClick={start.onAction}
          >
            {start.label}
          </button>
        ) : null}
      </div>
      {start?.manual ? (
        <textarea
          className={s.manual}
          readOnly
          rows={3}
          value={start.manual}
          aria-label="Prompt for your local agent"
          onFocus={(event) => event.currentTarget.select()}
        />
      ) : null}
    </div>
  );
}
